export default __webpack_public_path__ + "static/media/img-mwa-user-experience-05.9338a3c4.png";